<template>
  <div class="logo-box"
       @click="reloadSite">
    <img v-if="IS_CORDOVA_APP"
         :src="trans.logoUrl"/>
    <img v-else
         :src="trans.logoUrl"/>
    <span class="site-name"><span class="black-title">{{ trans.sideNameFirstPart }}</span>{{ trans.sideNameSecondPart }}</span>
    v{{ version }}
  </div>
</template>

<script>
import config from '@/config'
import {mapState} from 'vuex'

export default {
  data () {
    return {
      version: config.CURRENT_VERSION,
      IS_CORDOVA_APP: config.IS_CORDOVA_APP,
    }
  },
  methods: {
    reloadSite () {
      location.reload()
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.topMenu,
    }),
  },
}
</script>

<style scoped>

.logo-box {
  cursor: pointer;
}

.site-name {
  color: white;
  min-width: 9rem;
  font-weight: 600;
  font-size: 1rem;
  letter-spacing: 3px;
}

img {
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 0.5rem;
}

.black-title {
  color: #000;
}
</style>
